import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/relatorios/controle-adesoes'

class ControleAdesoesApiClient {
	async buscarAtas({ paginacao, numeroAta }) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/buscar-atas`,
			filters: { numeroAta },
			pagingAndSorting: paginacao,
		}).build()

		return await axios.get(url)
	}

	async gerarRelatorioAdesao(idAta) {
		return await axios.get(`${URL_PATH}/${idAta}/gerar`, {
			responseType: 'arraybuffer',
		})
	}
}

export default new ControleAdesoesApiClient()
